import { kebabCase } from "lodash";

const MONTHLY_SALES_REFRESH_CALENDAR_DATE = 20;
const SALES_TARGET_STARTED_DATE = "2025-09-20";

const STORAGE_PREFIX = "sales-dashboard";
const SYSTEM_STAT_PREFIX = "system-stat";
const DATE_FORMAT = "YYYY-MM-DD";
const FULL_MONTH_NAME_FORMAT = "MMMM";
const LEGEND_DATE_FORMAT = "MMM DD";
const AD_SALES_TYPE = Object.freeze({
  NEW: "NEW",
  RENEW: "RENEW",
  ALL: "ALL",
});

const AD_TARGET_RATIO = Object.freeze({
  [AD_SALES_TYPE.RENEW]: 0.6,
  [AD_SALES_TYPE.NEW]: 0.4,
});

const STORAGE_KEY_MAP = {
  MONTHLY_SALES_REFRESH_CALENDAR_DATE: `${STORAGE_PREFIX}-${kebabCase(
    "MONTHLY_SALES_REFRESH_CALENDAR_DATE"
  )}`,
  SALES_TARGET_STARTED_DATE: `${STORAGE_PREFIX}-${kebabCase(
    "SALES_TARGET_STARTED_DATE"
  )}`,
};

const PageConfig = {
  MONTHLY_SALES_REFRESH_CALENDAR_DATE,
  SALES_TARGET_STARTED_DATE,
  STORAGE_PREFIX,
  STORAGE_KEY_MAP,
  SYSTEM_STAT_PREFIX,
  DATE_FORMAT,
  FULL_MONTH_NAME_FORMAT,
  AD_SALES_TYPE,
  LEGEND_DATE_FORMAT,
  AD_TARGET_RATIO,
};

export default PageConfig;
